import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

/**
 *
 * @param params
 * @returns {function(*): *}
 */
export const getLearningFramework = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/learningframework`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_MANY_DIMENSIONS,
                    payload: {
                        dimensions: body.dimensions
                    }
                });
                dispatch({
                    type: ACTIONS.GET_MANY_ABILITIES,
                    payload: {
                        abilities: body.abilities
                    }
                });
                dispatch({
                    type: ACTIONS.GET_MANY_BEHAVIORS,
                    payload: {
                        behaviors: body.behaviors
                    }
                });
                dispatch({
                    type: ACTIONS.GET_LEARNING_FRAMEWORK,
                    payload: {
                        learningFramework: body.learningFramework
                    }
                });
                return body;
            })
            .catch(console.error);
};

/**
 *
 * @param params
 * @returns {function(*): *}
 * Admin only
 */
export const getManyLearningFrameworks = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/learningframeworks`;
    const url = buildQueryString(rest, baseUrl);
    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_MANY_LEARNING_FRAMEWORKS,
                    payload: {
                        learningFrameworks: body
                    }
                });
                return body;
            })
            .catch((err) => err);
};

/**
 *
 * @param params
 * @returns {function(*): *}
 * Admin only
 */
export const adminGetLearningFramework = (params) => {
    const { learningFrameworkId, pathsContext } = params;
    const url = `${pathsContext.adminServerUrl}/learningframeworks/${learningFrameworkId}`;
    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_LEARNING_FRAMEWORK,
                    payload: {
                        learningFramework: body
                    }
                });
                return body;
            })
            .catch((err) => err);
};

/**
 *
 * @param params
 * @returns {function(*): *}
 * Admin only
 */
export const postLearningFramework = (params) => {
    const { body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/learningframeworks`;
    const fetchOptions = {
        method: 'POST',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_LEARNING_FRAMEWORK_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.POST_LEARNING_FRAMEWORK_SUCCESS,
                    payload: {
                        learningFramework: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

/**
 *
 * @param params
 * @returns {function(*): *}
 * Admin only
 */
export const putLearningFramework = (params) => {
    const { learningFrameworkId, body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/learningframeworks/${learningFrameworkId}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_LEARNING_FRAMEWORK_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_LEARNING_FRAMEWORK_SUCCESS,
                    payload: {
                        learningFramework: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};
